document.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash === '#kit-added') {
      const tryOpenCart = () => {
        const cartButton = document.querySelector('.cart-button');
        if (cartButton) {
          cartButton.click();
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 3000);
        } else {
          // Try again after 100ms
          setTimeout(tryOpenCart, 500);
        }
      };
  
      tryOpenCart();
    }

    $(document).on('click', '.steps .step.normal:not(.active):not(.showed), .steps .step.extra:not(.active):not(.showed), .container-inner-list .saved-product.not-change', function (e) {        
        $('#tooltip-steps').addClass('show');
        $('#tooltip-steps-mobile').addClass('show');
        setTimeout(function() {
          $('#tooltip-steps').removeClass('show');
          $('#tooltip-steps-mobile').removeClass('show');
        }, 3000);
      
    });


    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          $('.container-list').addClass('hide');
        } else {
          $('.container-list').removeClass('hide');
        }
      });
    }, {
      threshold: [0.8] 
    });
    
    const footerElement = document.querySelector('.footer-main');
    if (footerElement) {
      footerObserver.observe(footerElement);
    }

    $(function() {
    let lastScrollTop = 0;

      $(window).on("scroll", function() {
        let st = $(this).scrollTop();
        if (st ) {
          if (st > lastScrollTop) {
            console.log("scroll down");
            $(".container-list").removeClass("expand");
            $(".container-inner-list").removeClass("show");
            $(".container-close").removeClass("show");
          } else if (st < lastScrollTop) {
            console.log("scroll up");
            $(".container-list").addClass("expand");
            $(".container-inner-list").removeClass("show");
            $(".container-close").removeClass("show");
          }
        } else {
          $(".container-list").removeClass("expand");
          $(".container-inner-list").removeClass("show");
          $(".container-close").removeClass("show");
        }

        lastScrollTop = st;
      });
    });
  });